import { cn } from '@repo/lib/cn';

import type { PlayerTimeProps } from '.';

import { useMedia } from '..';

export function PlayerTime(playerTimeProps: PlayerTimeProps) {
  const { type, className, ...props } = playerTimeProps;
  const { currentTime, duration, formatTime } = useMedia();
  return (
    <span className={cn('min-w-0 font-mono text-xs', className)} {...props}>
      {type === 'current' ? formatTime(currentTime) : formatTime(duration)}
    </span>
  );
}
